import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import { AdministrationServicePath, WARDS } from "utils/constants";

import permissions from "app/permissions";
import { tenants } from "utils/tenants";
import ListWards from "./List";
import CreateWards from "./Create";
import EditWards from "./Edit";
import ShowWards from "./Show";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <CalendarViewWeekIcon />,
  name: AdministrationServicePath + WARDS,
  title: "Болнични отделения",
  list: <ListWards />,
  create: <CreateWards />,
  edit: <EditWards />,
  show: <ShowWards />,

  permission: permissions.canPreviewWards,
};
